import { render, staticRenderFns } from "./purchase-method-noti.vue?vue&type=template&id=6a130d59&scoped=true&"
import script from "./purchase-method-noti.vue?vue&type=script&lang=js&"
export * from "./purchase-method-noti.vue?vue&type=script&lang=js&"
import style0 from "./purchase-method-noti.vue?vue&type=style&index=0&id=6a130d59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a130d59",
  null
  
)

export default component.exports